import { TypePromiseInfo } from '@services/ServiceCart/TypePromise';

export const defaultCart: TypePromiseInfo = {
  cartList: [],
  compareList: [],
  wishList: [],
  email: '',
};
